/** JaxPainter — 2D staff fighter silhouette. */
import { paintFighterBuffCues } from './paintFighterBuffCues.js';

export const JaxPainter = {
  paint(ctx, _pos, radius, entity) {
    ctx.beginPath();
    ctx.arc(0, 0, radius * 0.9, 0, Math.PI * 2);
    ctx.fillStyle = '#334155';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(radius * 0.6, -radius * 1.1);
    ctx.lineTo(radius * 0.75, radius * 1.0);
    ctx.lineTo(radius * 0.45, radius * 1.0);
    ctx.closePath();
    ctx.fillStyle = '#92400e';
    ctx.fill();
    paintFighterBuffCues(ctx, radius, entity);
  }
};
